// extracted by mini-css-extract-plugin
module.exports = {"videoEmbbed":"styles_videoEmbbed__4bfEB","videoEmbbed1":"styles_videoEmbbed1__DFy86","playerHolder":"styles_playerHolder__LpebF","holder":"styles_holder__SfA3V"};